import React from "react";
import {NavLink} from "react-router-dom";

function PageNotFound() {
    return (
        <div className="wraper_404" style={{minHeight: 'calc(100vh - 374px)'}}>
            <h1>404</h1>
            <h3 className="mt-2">Oops!</h3>
            <p className="mt-2">Page Not Found</p>
            <NavLink to={"/"} className="home_btn text-decoration-none mt-4 btn_bg" type="button">Back to Home</NavLink>
        </div>
    );
}

export default PageNotFound;